import { RadiatorOffIcon } from './RadiatorOffIcon';

/**
 * author: Michael Irigoyen
 * id F1BF1F5D-82C7-41EA-B9CD-325265C3D760
 * name radiator-off
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiator-off.svg
 * tags
 * - Home Automation 
 */
export const HeaterOffIcon = RadiatorOffIcon;
export default HeaterOffIcon